import { FC } from 'react';
import { Box, Button, Typography, keyframes } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/rootReducerType';
import { Certification } from 'src/types/Certification';

const checkmarkPop = keyframes`
  0% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
`;

interface HouseholdConfirmSuccessViewProps {
  onNext: () => void;
}

const HouseholdConfirmSuccessView: FC<HouseholdConfirmSuccessViewProps> = ({
  onNext,
}) => {
  const certifications = useSelector(
    (state: RootState) => state.newRenterInterface.certifications
  ) as Certification[];
  const householdsConfirmed = useSelector(
    (state: RootState) => state.newRenterInterface.householdsConfirmed
  );
  const unconfirmedHouseholds = useSelector(
    (state: RootState) => state.newRenterInterface.unconfirmedHouseholds
  );

  const confirmedCertId = householdsConfirmed[0] ?? null;
  const confirmedCert = confirmedCertId
    ? certifications.find((c) => c.id === confirmedCertId)
    : null;
  const propertyName = confirmedCert?.property?.name ?? null;
  const hasMore = unconfirmedHouseholds.length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 280,
        gap: 2,
      }}
    >
      <CheckCircleIcon
        sx={{
          fontSize: 80,
          color: 'success.dark',
          animation: `${checkmarkPop} 0.5s ease-out forwards`,
        }}
      />
      <Typography variant="h5" fontWeight={600}>
        {hasMore ? 'Thank you!' : 'All done!'}
      </Typography>
      <Typography variant="subtitle1" color="text.secondary">
        {propertyName
          ? `Household in ${propertyName} confirmed!`
          : 'Household confirmed!'}
      </Typography>
      <Button variant="contained" size="large" onClick={onNext} sx={{ mt: 1 }}>
        {hasMore ? 'Next' : 'Close'}
      </Button>
    </Box>
  );
};

export default HouseholdConfirmSuccessView;
